import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './Sidebar.css';
import { Link } from 'react-router-dom';
import Icon from '../Icon/Icon';

const NavItem = (props) => {
  const activeClass = (props.location === props.to) ? 'admin-navigation__nav-item--active' : ''
  if (props.expanded) {
    return (
      <div className={'admin-navigation__nav-item admin-navigation__nav-item--expanded ' + activeClass}>
        <Link to={props.to}>{props.children} <span>{props.text}</span></Link>
      </div>
    )
  }
  return (
    <div className={'admin-navigation__nav-item ' + activeClass}>
      <Link to={props.to}>{props.children}</Link>
    </div>
  )
}

class Sidebar extends Component {

  render() {

    return (
      <div className="sidebar">
        <NavItem expanded={this.props.expanded} text="Dashboard" to="/admin/dashboard" location={this.props.location}>
          <Icon icon="recruiters"/>
        </NavItem>
      </div>  
    );
  }
}

Sidebar.propTypes = {
  
};

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/UI/Sidebar/Sidebar.js